import React from 'react';
import { InfoField } from '@components-clean/core/info-field';
import { useTranslation } from '@hooks/index';

const NoWidgetsPlaceholder = () => {
    const { t } = useTranslation('cm');
    return <InfoField message={t('common:pleaseAddWidget')} type="Info" layout="center" />;
};

export { NoWidgetsPlaceholder };
